"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingLayer = void 0;
const FixRatioContainer_1 = require("../Common/FixRatioContainer");
const inversify_1 = require("inversify");
const Constants_1 = require("../Core/Constants");
const pixi_js_1 = require("pixi.js");
const InCodeAssests_1 = require("../Utils/InCodeAssests");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const Animation_1 = require("../Common/Animation/Animation");
const GameConfig_1 = require("../Core/GameConfig");
class LoadProgress {
    constructor() {
        this.progress = 0;
        this.targetProgress = 0;
        this.finished = false;
    }
    set(target) {
        this.targetProgress = target;
        if (target >= 1)
            this.finished = true;
    }
    /**
     *
     * @param dt 以秒计
     */
    update(dt) {
        this.progress += dt * (this.targetProgress - this.progress) * 5;
        if (this.finished) {
            this.progress += dt * 0.1;
            if (this.progress > 1) {
                this.progress = 1;
                return true;
            }
        }
    }
}
let LoadingLayer = class LoadingLayer extends pixi_js_1.Container {
    constructor(events, config) {
        super();
        this.progress = new LoadProgress();
        const backtexture = pixi_js_1.Texture.from(InCodeAssests_1.LoadingBackground);
        const back = new pixi_js_1.TilingSprite(backtexture, ...events.Resize.prevArgs);
        this.addChild(back);
        const container = new FixRatioContainer_1.FixRatioContainer(Constants_1.LayerWidth, Constants_1.LayerHeight);
        container.resize(...events.Resize.prevArgs);
        const text = new pixi_js_1.Text(InCodeAssests_1.LoadingMessages[0], {
            fontSize: 72,
            fill: "white",
        });
        text.position.set(400, 330);
        text.scale.set(0.5);
        container.addChild(text);
        const barback = new pixi_js_1.Graphics().beginFill(0x808080).drawRoundedRect(0, 0, 480, 18, 8).endFill();
        barback.position.set(400, 380);
        container.addChild(barback);
        const bar = new pixi_js_1.Graphics();
        bar.position.set(400, 380);
        container.addChild(bar);
        this.addChild(container);
        const textanim = this.setTextAnim(text, events.Update);
        events.Resize.add((remove, w, h) => {
            if (!this.parent)
                return remove();
            back.width = w;
            back.height = h;
            back.tileScale.set(Math.max(w, h) / 1000);
            container.resize(w, h);
        });
        let lastProg = 0;
        events.Update.add((remove, dt) => {
            if (!this.parent)
                return remove();
            back.tilePosition.x += dt * 20;
            back.tilePosition.y += dt * 10;
            textanim.update(dt);
            this.progress.update(dt);
            const progress = this.progress.progress;
            if (progress > 0.04 && lastProg !== progress) {
                lastProg = progress;
                bar.clear()
                    .beginFill(0xe93f5f)
                    .drawRoundedRect(0, 0, 480 * progress, 18, 8)
                    .endFill();
            }
        });
        this.messages = config.loadingMessages || InCodeAssests_1.LoadingMessages;
    }
    getRandomMessage(prev = "") {
        let str = prev;
        while (str === prev) {
            const i = Math.floor(Math.random() * this.messages.length);
            str = this.messages[i];
        }
        return str;
    }
    setTextAnim(text, update) {
        let timeout = 5;
        const textanim = new Animation_1.AnimationManager(Animation_1.CreatePixiPropSetter(text));
        textanim.paused = true;
        const anim1 = Animation_1.createSimpleAnimation(1, 0, 0.3, Animation_1.keyFramePresets.easeOut);
        const anim2 = Animation_1.createSimpleAnimation(text.x, text.x - 20, 0.3, Animation_1.keyFramePresets.easeOut);
        const changeText = () => {
            if (!this.parent)
                return;
            textanim.paused = false;
            textanim.animations.set("alpha", anim1);
            textanim.animations.set("x", anim2);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            textanim.onEnd.add(changeText2);
        };
        const anim3 = Animation_1.createSimpleAnimation(0, 1, 0.3, Animation_1.keyFramePresets.easeOut);
        const anim4 = Animation_1.createSimpleAnimation(text.x + 20, text.x, 0.3, Animation_1.keyFramePresets.easeOut);
        const changeText2 = (remove) => {
            text.text = this.getRandomMessage(text.text);
            textanim.currentTime = 0;
            textanim.animations.set("alpha", anim3);
            textanim.animations.set("x", anim4);
            textanim.onEnd.add(remove => {
                textanim.paused = true;
                textanim.currentTime = 0;
                timeout = 5;
                return remove();
            });
            return remove();
        };
        update.add((remove, dt) => {
            if (!this.parent)
                return remove();
            timeout -= dt;
            if (timeout < 0 && timeout + dt >= 0)
                changeText();
        });
        return textanim;
    }
};
LoadingLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.GlobalEvents, GameConfig_1.GameLoadConfig])
], LoadingLayer);
exports.LoadingLayer = LoadingLayer;
//# sourceMappingURL=LoadingLayer.js.map